import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import Marketplace from "@/pages/Marketplace";
import ScriptDetails from "@/pages/ScriptDetails";
import WriterLanding from "@/pages/WriterLanding";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import BuyerDashboard from "@/pages/BuyerDashboard";
import WriterDashboard from "@/pages/WriterDashboard";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-20 text-center text-white/60">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  const location = useLocation();
  // Emergent OAuth callback comes back with #session_id=...
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="App min-h-screen bg-[#070707] text-white font-body">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/scripts/:scriptId" element={<ScriptDetails />} />
        <Route path="/writers" element={<WriterLanding />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/dashboard/buyer" element={<ProtectedRoute><BuyerDashboard /></ProtectedRoute>} />
        <Route path="/dashboard/writer" element={<ProtectedRoute><WriterDashboard /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><DashboardRedirect /></ProtectedRoute>} />
      </Routes>
      <Footer />
    </div>
  );
}

function DashboardRedirect() {
  const { user } = useAuth();
  if (user?.role === "writer" || user?.role === "admin") return <Navigate to="/dashboard/writer" replace />;
  return <Navigate to="/dashboard/buyer" replace />;
}
